import {Button, Image, Result} from "antd-mobile";
import {useNavigate, useSearchParams} from "react-router-dom";

const OpayFinish = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    const backAction = () => {
        const from = searchParams.get('from');
        if (from) {
            navigate(from);
        } else {
            navigate(-1);
        }
    }
    return <div style={{backgroundColor: '#F5F6FA', height: '100vh', display: "flex", flexDirection: "column", padding: '0 12px', justifyContent: "center", textAlign: "center"}}>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 25}}>
            <Image src={require('../../assets/nga_logo.png')} style={{width: 100}}/>
        </div>
        <Result status='success' title='Repayment Successful' description='Your repayment has been processed successfully.'/>
        <div>
            <Button onClick={backAction} shape='rounded' block type='submit' color='primary' size='middle'>Back</Button>
        </div>
    </div>
}
export default OpayFinish
